import * as React from 'react';
import { ConnectedListContainer } from '../../common/components/list-container';
import { LocationListItem } from './list-item';
import { ConnectedFiltersHeader } from '../../common/components/filters-header';
import { ConnectedFilterTextbox } from '../../common/components/filter-textbox';
import { ConnectedFilterRadio } from '../../common/components/filter-radio';
import { ConnectedSort } from '../../common/components/sort-options';
import { ConnectedClearAll } from '../../common/components/clear-all';
import ConnectedDashBoard from '../../common/components/result-dashboard';
import { ConnectedScrollToTop } from '../../common/components/scroll-to-top';
import { AppExternalProps } from '../../event/components/app';

import { connect } from 'react-redux';
import { IAppState } from '../../common/classes/app';
import { localStoreCacheKey } from '../../common/redux-state';
import { ConnectedFilterChecklist } from '../../common/components/filter-checklist';

interface StateToProps {
    isMobile: boolean;
    hideNetworkFilter: boolean;
}
interface ExternalProps {
    hospitalSearch: boolean
    locationSearchUrl: string
}

type ProviderAppProps = StateToProps & AppExternalProps & ExternalProps;

const ProviderAppBase: React.StatelessComponent<ProviderAppProps> = props => {

    function ClearCache() {

        localStorage.removeItem(localStoreCacheKey());
    }
    return (
        <div>
            <div className="adage-search-input">
                <div className="adage-search-input-inner">
                    <h1>Find a Location</h1>
                    <ConnectedFilterTextbox clickToSubmit={true} property="QueryValue" title="" defaultTextBoxValue={props.searchBoxDefault} showMoreLink={true} />
                </div>
            </div>

            <div className="adage-search">
                <div className="adage-search-rail">
                    <div className="adage-search-filters adage-search-rail-inner adage-search-rail-inner-js">
                        <ConnectedFiltersHeader />

                        <div id="searchFilters" className="adage-search-filters-content" aria-hidden={props.isMobile ? "true" : null}>
                            {
                                props.hospitalSearch ?
                                    <div className="adage-search-filters-facets">
                                        <div className="adage-search-filters-facets-column">
                                            <div className="adage-search-facet-group adage-search-facet-group-message">
                                                <p> You are now searching within a Hospital Network.&nbsp;
                                                <a href={props.locationSearchUrl} onClick={ClearCache}>Click Here</a>&nbsp;
                                                        to go back to Site Location Search.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className="adage-search-reset">
                                <ConnectedClearAll text="Clear All" />
                            </div>

                            <div className="adage-search-filters-facets">
                                <div className="adage-search-filters-facets-column">
                                    <div className="adage-search-facet-group">
                                        <h3 className="adage-search-facet-group-title">Location</h3>
                                        <ConnectedFilterTextbox clickToSubmit={false} property="ziporcity" title="Zip or City" showMoreLink={false}  />
                                    </div>
                                </div>

                                <div className="adage-search-filters-facets-column">
                                    <div className="adage-search-facet-group">
                                        <h3 className="adage-search-facet-group-title">Location Information</h3>
                                        <ConnectedFilterRadio property="locationtype" title="Location Types" defaultOption={{ text: "All Locations", value: "" }} />
                                        {!props.hideNetworkFilter ? <ConnectedFilterChecklist property="network" title="Health Networks" /> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="adage-search-main">
                    <ConnectedListContainer itemType="Locations" providerFilters="" listItemComponent={props => <LocationListItem key={props.id} {...props} />} />
                </div>

                <ConnectedScrollToTop />
            </div>
        </div>
    )
}

function mapStateToProps(state: IAppState): StateToProps {
    return {
        isMobile: state.responsiveState.isMobile,
        hideNetworkFilter: state.filtersState.hideNetworkFilter
    }
}

export const ProviderApp = connect(mapStateToProps)(ProviderAppBase);